import { render, staticRenderFns } from "./FavoriteModal.vue?vue&type=template&id=0dbd187a"
import script from "./FavoriteModal.vue?vue&type=script&lang=js"
export * from "./FavoriteModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports